import { render } from "./Cronometer.vue?vue&type=template&id=3b75352c&ts=true"
import script from "./Cronometer.vue?vue&type=script&lang=ts"
export * from "./Cronometer.vue?vue&type=script&lang=ts"

import "./Cronometer.vue?vue&type=style&index=0&id=3b75352c&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__